webpackJsonp([5],{

/***/ "D00/":
/***/ (function(module, exports) {

!function (a) {
  a.fn.datepicker.dates.fr = {
    days: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
    daysShort: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
    daysMin: ["d", "l", "ma", "me", "j", "v", "s"],
    months: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
    monthsShort: ["janv.", "févr.", "mars", "avril", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
    today: "Aujourd'hui",
    monthsTitle: "Mois",
    clear: "Effacer",
    weekStart: 1,
    format: "dd/mm/yyyy"
  };
}(jQuery);

/***/ }),

/***/ "eIos":
/***/ (function(module, exports, __webpack_require__) {

// console.log('Loading fr.js ...');

__webpack_require__("D00/");
__webpack_require__("qT/I");

/***/ }),

/***/ "qT/I":
/***/ (function(module, exports) {

Lang = function () {
  var phraseBook = null;
  var staticUrl = '/';
  if (document.body.dataset.staticContentUrl != null) {
    staticUrl = document.body.dataset.staticContentUrl;
  }
  $.getJSON(staticUrl + "js/lang/lang-fr.json", function (json) {
    phraseBook = json;
  });
  return {
    translate: function translate(phrase) {
      return phraseBook[phrase];
    },
    ready: function ready() {
      return phraseBook != null;
    }
  };
}();

/***/ })

},["eIos"]);


// WEBPACK FOOTER //
// fr.16e4411f972413f5a820.js